<div class="add-payment">
  <div class="ui-g-12 p-zero dialog-header">
    <div class="send-dialog-heading">{{ isFinalizeBackdate? 'Update finalization date':'Update invoice date' }}</div>
    <i class="fal fa-times fa-sm dialog-close" (click)="closePaymentModal()"></i>
  </div>

  <div class="dialog-body">
    <!-- Finalization date CARD -->
    <div class="date-card mb-2" *ngIf="isFinalizeBackdate">
      <div class="p-10p">
        <div class="flex-between-start">
          <div>
            <span style="font-weight: bold;">Finalization date</span>
            <span class="ml-2 font-12 px-2 red">Required</span>
          </div>
          <div>
            <i class="pointer far font-16 mr-2 font-gray-45"
              [ngClass]="[isOpenAccordion.finalize ? 'fa-chevron-down' : 'fa-chevron-up']"
              (click)="handleDateCardAccordion('finalize')"> </i>
          </div>
        </div>
        <span class="font-13" style="color: var(--secondary-400);">Selecting a date prior to invoice / RO creation date
          will impact other dates
        </span>
      </div>
      <div class="divider"></div>
      <div *ngIf="!isOpenAccordion.finalize" class="p-10p">
        <span class="font-13 pl-1" style="color: var(--secondary-400);">Current finalization date: {{
          data.finalizeBy.date }}, {{
          data.finalizeBy.time }}</span>
        <div class="customer-calendar-wrapper">
          <div class="calendar-input mr-2">
            <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Finalization date*</p>
            <div class="dynamic-calender-setting d-flex" (click)="enableCalendarFocus(invoiceDateCalendar)">
              <p-calendar id="start-date" dateFormat="M dd, yy" inputStyleClass="pointer" [readonlyInput]="true"
                [(ngModel)]="finalizeDateTime.date" [maxDate]="dateRange" appendTo="body" [showOnFocus]="isCalendarFocusEnabled"
                panelStyleClass="update-modal-cal" (onSelect)="onSelectFinalizeeDateTime('date', $event)"
                #invoiceDateCalendar>
              </p-calendar>
              <i class="fal fa-calendar font-gray-75 invoice-date-icon pointer" style="align-self: center;"
                ></i>
            </div>
          </div>

          <div class="calendar-input">
            <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Finalization time*</p>
            <div class="time-dropdown">
              <kendo-timepicker [(value)]="finalizeDateTime.time" [readOnlyInput]="true"
                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"
                (valueChange)="onSelectFinalizeeDateTime('time', $event)"> </kendo-timepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isFinalizeBackdate && isFinalizsBackDated" class="my-2">
      <span class="error-msg font-11">The selected finalization date is prior to the RO creation date. Backdating the
        finalization
        date will impact the dates below:</span>
    </div>

    <!-- INVOICE DATE CARD -->
    <div class="date-card" *ngIf="isShowFinalizeModal">
      <div class="p-10p">
        <div class="flex-between-start">
          <div>
            <span style="font-weight: bold;">Invoice date</span>
            <span class="ml-2 font-12 px-2 red">Required</span>
          </div>
          <div>
            <i class="pointer far font-16 mr-2 font-gray-45"
              [ngClass]="[isOpenAccordion.invoice ? 'fa-chevron-down' : 'fa-chevron-up']"
              (click)="handleDateCardAccordion('invoice')"> </i>
          </div>
        </div>
        <span class="font-13" style="color: var(--secondary-400);">Selecting a date prior to RO creation date will
          impact other dates
        </span>
      </div>
      <div class="divider"></div>
      <div *ngIf="!isOpenAccordion.invoice" class="p-10p">
        <span class="font-13 pl-1" style="color: var(--secondary-400);">Current invoice date: {{ data.invoiceBy.date }},
          {{
          data.invoiceBy.time }}</span>
        <div class="customer-calendar-wrapper">
          <div class="calendar-input mr-2">
            <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Invoice date*</p>
            <div class="dynamic-calender-setting d-flex" (click)="enableCalendarFocus(invoiceDateCalendar)">
              <p-calendar id="start-date" dateFormat="M dd, yy" inputStyleClass="pointer" [readonlyInput]="true"
                [(ngModel)]="invoiceDateTime.date" [maxDate]="finalizeDateTime.date ? finalizeDateTime.date : invoiceDateTime.date " appendTo="body" [showOnFocus]="isCalendarFocusEnabled"
                panelStyleClass="update-modal-cal" (onSelect)="onSelectInvoiceDateTime('date', $event)"
                #invoiceDateCalendar>
              </p-calendar>
              <i class="fal fa-calendar font-gray-75 invoice-date-icon pointer" style="align-self: center;"></i>
            </div>
          </div>

          <div class="calendar-input">
            <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Invoice time*</p>
            <div class="time-dropdown">
              <kendo-timepicker [(value)]="invoiceDateTime.time" [readOnlyInput]="true"
                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"
                (valueChange)="onSelectInvoiceDateTime('time', $event)"> </kendo-timepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isInvoiceBackDated" class="my-2">
      <span class="error-msg font-11">The selected invoice date is prior to the RO creation date. Backdating the invoice
        date will impact the dates below:</span>
    </div>

    <!-- CREATION DATE CARD -->
    <div *ngIf="isInvoiceBackDated" class="date-card">
      <div class="p-10p">
        <div class="flex-between-start">
          <div>
            <span style="font-weight: bold;">Creation date</span>
            <span class="ml-2 font-12 px-2 red">Required</span>
          </div>
          <div>
            <i class="pointer far font-16 mr-2 font-gray-45"
              [ngClass]="[isOpenAccordion.created ? 'fa-chevron-down' : 'fa-chevron-up']"
              (click)="handleDateCardAccordion('created')"> </i>
          </div>
        </div>
        <span class="font-13" style="color: var(--secondary-400);">The order creation date must be prior to the new
          invoice date.
        </span>
      </div>
      <div class="divider"></div>
      <div *ngIf="!isOpenAccordion.created" class="p-10p">
        <span class="font-13 pl-1" style="color: var(--secondary-400);">Current creation date: {{ data.createdBy.date
          }}, {{
          data.createdBy.time }}</span>
        <div class="customer-calendar-wrapper">
          <div class="calendar-input mr-2">
            <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Creation date*</p>
            <div class="dynamic-calender-setting d-flex">
              <p-calendar id="start-date" dateFormat="M dd, yy" inputStyleClass="pointer" [readonlyInput]="true"
                [(ngModel)]="createdDateTime.date" [maxDate]="invoiceDateTime.date" #invoiceDateCalendar>
              </p-calendar>
              <i class="fal fa-calendar font-gray-75 invoice-date-icon pointer" style="align-self: center;"
                (click)="invoiceDateCalendar.showOverlay()"></i>
            </div>
          </div>

          <div class="calendar-input">
            <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Creation time*</p>
            <div class="time-dropdown">
              <kendo-timepicker [(value)]="createdDateTime.time" [readOnlyInput]="true"
                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"> </kendo-timepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- AUTHORIZATION DATE CARD -->
    <div *ngIf="isInvoiceBackDated" class="date-card mt-3">
      <div class="p-10p">
        <div class="flex-between-start">
          <div>
            <span style="font-weight: bold;">Authorization date</span>
            <span class="ml-2 font-12 px-2 red">Required</span>
          </div>
          <div>
            <i class="pointer far font-16 mr-2 font-gray-45"
              [ngClass]="[isOpenAccordion.authorize ? 'fa-chevron-down' : 'fa-chevron-up']"
              (click)="handleDateCardAccordion('authorize')"> </i>
          </div>
        </div>
        <span class="font-13" style="color: var(--secondary-400);">The order authorization date must be after the new
          creation date
          and prior to the new invoice date. </span>
      </div>
      <div class="divider"></div>
      <div *ngIf="!isOpenAccordion.authorize" class="p-10p">
        <!-- {{ invoiceBy.date }}, {{ invoiceBy.time }} -->
        <span class="font-13 pl-1" style="color: var(--secondary-400);">Current authorization date: {{
          data.authorizedBy.date }}, {{
          data.authorizedBy.time }}</span>
        <div class="customer-calendar-wrapper">
          <div class="calendar-input mr-2">
            <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Authorization date*</p>
            <div class="dynamic-calender-setting d-flex">
              <p-calendar id="start-date" dateFormat="M dd, yy" inputStyleClass="pointer" appendTo="body"
                panelStyleClass="update-modal-cal" [readonlyInput]="true" [(ngModel)]="authDateTime.date"
                [maxDate]="invoiceDateTime.date" [minDate]="createdDateTime.date" #invoiceDateCalendar>
              </p-calendar>
              <i class="fal fa-calendar font-gray-75 invoice-date-icon pointer" style="align-self: center;"
                (click)="invoiceDateCalendar.showOverlay()"></i>
            </div>
          </div>

          <div class="calendar-input">
            <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Authorization time*</p>
            <div class="time-dropdown">
              <kendo-timepicker [(value)]="authDateTime.time" [readOnlyInput]="true"
                [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"> </kendo-timepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isInvoiceBackDated && paymentHistory.length > 0" class="date-card mt-3">
      <div class="p-10p">
        <div class="flex-between-start">
          <div>
            <span style="font-weight: bold;">Payment date</span>
            <!-- <span class="ml-2 font-12 px-2 red">Required</span> -->
          </div>
          <div>
            <i class="pointer far font-16 mr-2 font-gray-45"
              [ngClass]="[isOpenAccordion.payment ? 'fa-chevron-down' : 'fa-chevron-up']"
              (click)="handleDateCardAccordion('payment')"> </i>
          </div>
        </div>
        <span class="font-13" style="color: var(--secondary-400);">Would you like to update the payment times? </span>
      </div>
      <div class="divider"></div>
      <div *ngIf="!isOpenAccordion.payment" class="p-10p">
        <!-- {{ invoiceBy.date }}, {{ invoiceBy.time }} -->
        <div *ngFor="let payment of paymentHistory; let i = index">
          <div class="flex-between-start">
            <span class="font-13 pl-1" style="color: var(--secondary-400);">
              {{ (payment?.paymentType | titlecase) }} - {{payment?.createdDate | date: 'MMM d, yyyy' | titlecase }}
            </span>

            <span class="font-13 mr-2 font-gray-light">
              {{ payment?.amount | currency: usd }}
            </span>
          </div>

          <div class="customer-calendar-wrapper">
            <div class="calendar-input mr-2">
              <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Payment date*</p>
              <div class="dynamic-calender-setting d-flex">
                <p-calendar id="start-date" dateFormat="M dd, yy" inputStyleClass="pointer" appendTo="body"
                  panelStyleClass="update-modal-cal" [readonlyInput]="true" [(ngModel)]="payment.paymentDateTime.date"
                  [minDate]="invoiceDateTime.date" #invoiceDateCalendar>
                </p-calendar>
                <i class="fal fa-calendar font-gray-75 invoice-date-icon pointer" style="align-self: center;"
                  (click)="invoiceDateCalendar.showOverlay()"></i>
              </div>
            </div>

            <div class="calendar-input">
              <p class="mt-1 pl-1 mb-0 font-12 fong-gray-45">Payment time*</p>
              <div class="time-dropdown">
                <kendo-timepicker [(value)]="payment.paymentDateTime.time" [readOnlyInput]="true"
                  [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"> </kendo-timepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isInvoiceBackDated" class="my-2">
      <span class="font-11" style="color: var(--secondary-400);">* Please note backdating the invoice will also impact
        customer
        created date, vehicle created date, and follow - ups</span>
    </div>
  </div>

  <div class="dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="closePaymentModal()">Cancel</button>
    <button id="payment-btn-save" class="btn btn-primary btn-submit" [disabled]="false" (click)="onSubmit()">
      <span [ngClass]="isProcessing ? 'mr-2' : ''"> {{ isInvoiceBackDated ? 'Backdate invoice and save updates' : 'Save'
        }}</span>
      <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
    </button>
  </div>
</div>

